// src/components/decks/decksSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../api'; // adjust if your axios instance is elsewhere

// Thunks for fetching and deleting decks
export const fetchDecks = createAsyncThunk(
  'decks/fetchDecks',
  async ({ userEmail, selectedBusinessId }, { rejectWithValue }) => {
    try {
      console.log('fetchDecks sending:', { email: userEmail, business_id: selectedBusinessId });
      
      const response = await api.post('/decks', { 
        email: userEmail,
        business_id: selectedBusinessId  // ✅ Fixed: Changed from businessId to business_id
     });
      return response.data;
    } catch (error) {
      console.error('fetchDecks error:', error.response?.data || error.message);
      return rejectWithValue(error.response?.data?.error || error.response?.statusText || error.message);
    }
  }
);

export const deleteDeck = createAsyncThunk(
  'decks/deleteDeck',
  async (deckId, { rejectWithValue }) => {
    try {
      const response = await api.delete(`/deck/${deckId}`);
      return { deckId }; // Return the deckId to remove it from state
    } catch (error) {
      return rejectWithValue(error.response?.statusText || error.message);
    }
  }
);

export const createDeck = createAsyncThunk(
  'decks/createDeck',
  async ({ deckName, selectedBusinessId }, { rejectWithValue }) => {
    try {
      console.log('createDeck sending:', { deck_label: deckName, business_id: selectedBusinessId });
      
      const response = await api.post('/deck', {
        deck_label: deckName,
        business_id: selectedBusinessId  // ✅ Fixed: Changed from businessId to business_id
      });
      return response.data;
    } catch (error) {
      console.error('createDeck error:', error.response?.data || error.message);
      return rejectWithValue(error.response?.data?.error || error.response?.statusText || error.message);
    }
  }
);

const decksSlice = createSlice({
  name: 'decks',
  initialState: {
    items: [],
    loadingCreateDeck: false,
    errorCreateDeck: null,
    successCreateDeck: false,
    loadingDeleteDeck: false,
    errorDeleteDeck: null,
    successDeleteDeck: false,
    loadingFetchDecks: false,
    errorFetchDecks: null,
    successFetchDecks: false,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      // Handle createDeck
      .addCase(createDeck.pending, (state) => {
        state.loadingCreateDeck = true;
        state.errorCreateDeck = null;
        state.successCreateDeck = false;
      })
      .addCase(createDeck.fulfilled, (state, action) => {
        state.loadingCreateDeck = false;
        state.errorCreateDeck = null;
        state.successCreateDeck = true;
        state.items.push(action.payload);
      })
      .addCase(createDeck.rejected, (state, action) => {
        state.loadingCreateDeck = false;
        state.errorCreateDeck = action.payload;
      })

      // Handle fetchDecks
      .addCase(fetchDecks.pending, state => {
        state.loadingFetchDecks = true;
        state.errorFetchDecks = null;
        state.successFetchDecks = false;
      })
      .addCase(fetchDecks.fulfilled, (state, action) => {
        state.loadingFetchDecks = false;
        state.errorFetchDecks = null;
        state.successFetchDecks = true;
        state.items = action.payload;
      })
      .addCase(fetchDecks.rejected, (state, action) => {
        state.loadingFetchDecks = false;
        state.successFetchDecks = false;
        state.errorFetchDecks = action.payload;
      })
      
      // Handle deleteDeck
      .addCase(deleteDeck.pending, state => {
        state.loadingDeleteDeck = true;
        state.errorDeleteDeck = null;
        state.successDeleteDeck = false;
      })
      .addCase(deleteDeck.fulfilled, (state, action) => {
        state.loadingDeleteDeck = false;
        state.successDeleteDeck = true;
        state.errorDeleteDeck = null;
        // Remove the deleted deck from the state by filtering it out based on deckId
        state.items = state.items.filter(deck => deck.deckId !== action.payload.deckId);
      })
      .addCase(deleteDeck.rejected, (state, action) => {
        state.loadingDeleteDeck = false;
        state.successDeleteDeck = false;
        state.errorDeleteDeck = action.payload; // ✅ Fixed: Changed from errorCreateDeck to errorDeleteDeck
      });
  },
});

export default decksSlice.reducer;